import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  CButton,
  CRow,
  CCol,
  CCardBody,
  CInputCheckbox,
  CFormGroup,
  CContainer,
} from '@coreui/react';
import Swal from 'sweetalert';
import ApiHelper from '../../utils/api/api_helper';
import TheHeader from './comm/TheHeader';
import TheNav from './comm/TheNav';
import TheFooter from './comm/TheFooter';
import ApoDocFormPop from './apoDocFormPop';
import ApoDocHdwtRegPop from './apoDocHdwtRegPop';
import {
  setApoDocHdwtData,
  setApoDocCnfmYn,
  setModifyApoDocCnfmYn,
  setModifyqlfcDocCnfmYn
} from '../../modules/apoDocForm';

const ApoDocFormPage = () => {
  const { apoDocForm, main, insert } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const corpNm = useLocation().pathname.split('/')[1];
  const pathParam = Number(useLocation().pathname.split('/')[2]);
  const [apoDocList, setApoDocList] = React.useState([]);
  const [apoDocAllChkYn, setApoDocAllChkYn] = React.useState([]);
  const [hasOtherSignM, setHasOtherSignM] = React.useState(false);
  const [hasOtherSignH, setHasOtherSignH] = React.useState(false);
  const [apoDocRegPop, setApoDocRegPop] = React.useState({
    isOpen: false,
    afcrNo: '',
  });
  const [hdwtRegPop, setHdwtRegPop] = React.useState({
    isOpen: false,
  });

  const onRegPopClose = (afcrNo) => {
    setApoDocRegPop({ isOpen: false });
    document.getElementsByTagName('body')[0].style.overflow = 'scroll';
    if(afcrNo < Number('90000') ){
      dispatch(setModifyApoDocCnfmYn(String(afcrNo)))
    }else if(afcrNo > Number('90000') ){
      let formCatDtlCd = String(afcrNo - 90000).padStart(5,"0");
      dispatch(setModifyqlfcDocCnfmYn(formCatDtlCd));
    };
  };

  const handelHdwtRegPopClose = () => {
    setHdwtRegPop({ isOpen: false });
    document.getElementsByTagName('body')[0].style.overflow = 'scroll';
  };

  function onRegistryClick(e) {
    const { formCatDtlCd } = e.target.dataset;
    
    const afcrNo  = (e.target.dataset.afcrNo == "" && formCatDtlCd!= "") ? 90000 + Number(formCatDtlCd) : e.target.dataset.afcrNo;

    if (corpNm !== 'gfk' && corpNm !=='megainfo'  && corpNm !=='sky' && (afcrNo === '10009' || (afcrNo === '10005' && corpNm !== 'mfs' && corpNm !=='gfk' && corpNm !=='GLOBAL'  && corpNm !=='megainfo'))) {
      return Swal(
        '위촉서류',
        '별도의 자필작성이 있으니 내용을 확인하시고, 반드시 자필작성을 진행해주세요.',
        'info',
      ).then(() => setApoDocRegPop({ isOpen: true, afcrNo }));
    }

    return setApoDocRegPop({ isOpen: true, afcrNo });
  };

  function onRegistryClickCheck(e) {
    const { afcrNo } = e.target.dataset;

    // 체크박스가 선택된 항목 & 위촉서류전체선택 0 경우만 checked 해제
    if(!e.target.checked && !apoDocAllChkYn){
      apoDocForm.apoDocCnfmYn.forEach((item) => {
        if(item.afcrNo == afcrNo){
          dispatch(setModifyApoDocCnfmYn(String(afcrNo), true));
        }
      });
    } else {
      onRegistryClick(e);
    }
  };

  const handelHdwtSign = () => {
    if(apoDocAllChkYn){
      for (const item of apoDocForm.apoDocCnfmYn) {
        if (!item.cnfmYn) {
          return Swal(
            '서류작성',
            '모든 위촉서류를 확인하셔야 서명이 가능합니다.',
            'info',
          );
        }
      }
    }
    setHdwtRegPop({ isOpen: true });
  };

  const handleHdwtForApoDocSave = (e, nextPage) => {
    const params = {};
    const data = [];
    let chkAfcrArr = [];
    let unchkAfcrArr = [];

    for (const item of apoDocForm.apoDocHdwtInfo) {
      if (item.update) {
        data.push({ hdwtCatCd: item.hdwtCatCd, imgData: item.data });
      }
    }

    chkAfcrArr = apoDocForm.apoDocCnfmYn.filter((item) => item.cnfmYn);
    unchkAfcrArr = apoDocForm.apoDocCnfmYn.filter((item) => !item.cnfmYn);

    params.reqNo = insert.reqTaskInfo.reqNo;
    params.data = JSON.stringify(data);
    
    if (nextPage) {
      if(apoDocAllChkYn){
        for (const item of apoDocForm.apoDocCnfmYn) {
          if (!item.cnfmYn) {
            return Swal(
              '서류작성',
              '모든 위촉서류를 확인하셔야 서명이 가능합니다.',
              'info',
            );
          }
        }
        if (corpNm !== 'gfk' && hasOtherSignM && corpNm !=='megainfo' && corpNm !=='GLOBAL' && corpNm !=='sky' ) {
          if (!apoDocForm.apoDocHdwtInfo[2].data) {
            return Swal(
              '서류작성',
              '모든 서류를 확인하시고, 서명을 하셔야 다음으로 이동이 가능합니다.',
              'error',
            );
          }
        }
        if (hasOtherSignH) {
          if (!apoDocForm.apoDocHdwtInfo[1].data) {
            return Swal(
              '서류작성',
              '모든 서류를 확인하시고, 서명을 하셔야 다음으로 이동이 가능합니다.',
              'error',
            );
          }
        }
        if (!apoDocForm.apoDocHdwtInfo[0].data) {
          return Swal(
            '서류작성',
            '모든 서류를 확인하시고, 서명을 하셔야 다음으로 이동이 가능합니다.',
            'error',
          );
        }
      }
      if (!apoDocForm.apoDocHdwtInfo[0].data && !apoDocAllChkYn) {
        return Swal(
          '서류작성',
          '서명을 하셔야 다음으로 이동이 가능합니다.',
          'error',
        );
      }
    }
    ApiHelper.request(
      ApiHelper.methods.post,
      '/cust/request/tempSaveStep4And5',
      params,
    )
      .then(({ data }) => {
        const newParams = { reqNo: insert.reqTaskInfo.reqNo };

        if (data.status === 'SUCCESS') {
          newParams.chkAfcrArr = JSON.stringify(chkAfcrArr);
          newParams.unchkAfcrArr = JSON.stringify(unchkAfcrArr);

          ApiHelper.request(
            ApiHelper.methods.post,
            '/cust/request/tempSaveStep5',
            newParams,
          )
            .then(({ data }) => {
              if (data.status === 'SUCCESS') {
                if (nextPage) {
                  history.push(`/${corpNm}/${pathParam + 1}`);
                } else {
                  return Swal('', '임시저장 되었습니다.', 'success');
                }
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  React.useEffect(() => {
    let rsltHdwtData = [];
    const rsltcnfmData = [];

    ApiHelper.request(ApiHelper.methods.post, '/cust/request/apoDocList', {
      corpNo: main.corpNo,
      taskNo: main.taskNo,
    })
      .then(({ data }) => {
        if (data.status === 'SUCCESS') {
          const result = data.data;
          for (const i of result) {
            if (i.AFCR_NO === '10005' && corpNm !== 'sky') {
              setHasOtherSignM(true);
            }
            if (i.AFCR_NO === '10009'&& corpNm !== 'sky') {
              setHasOtherSignH(true);
            }
          }
          setApoDocList(result);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    const setApoDocFormInitData = async () => {
      await ApiHelper.request(
        ApiHelper.methods.post,
        '/cust/request/hdwtInfo2',
        {
          reqNo: insert.reqTaskInfo.reqNo,
        },
      )
        .then(({ data }) => {
          if (data.status === 'SUCCESS') {
            rsltHdwtData = data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });

      await ApiHelper.request( 
        ApiHelper.methods.post,
        '/cust/request/apoDocCnfmInfo',
        {
          reqNo: insert.reqTaskInfo.reqNo,
          taskNo: main.taskNo,
        },
      )
        .then(({ data }) => {
          if (data.status === 'SUCCESS') {
            const result = data.data;

            if (result.length) {
              result.forEach((item) => {
                rsltcnfmData.push({
                  afcrNo: item.AFCR_NO,
                  formNo: item.FORM_NO,
                  formCatDtlCd: item.FORM_CAT_DTL_CD,
                  cnfmYn: item.CNFM_DTM != null,
                  update: false,
                });
              });
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
      await dispatch(setApoDocHdwtData(rsltHdwtData, true));
      await dispatch(setApoDocCnfmYn(rsltcnfmData));
    };

    if (apoDocForm.isFirst) {
      setApoDocFormInitData();
    }

    //위촉서류 체크 유무 가져오기
    ApiHelper.request(ApiHelper.methods.post, '/cust/request/apoDocAllChkYn', {
      corpNo: main.corpNo,
      taskNo: main.taskNo,
    })
      .then(({ data }) => {
        if (data.status === 'SUCCESS') {
          const result = data.data;
          setApoDocAllChkYn(Number(result.APO_DOC_ALL_CHK_YN));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={main.step} />
        <CContainer className="text-left">
          <h5>
            <b>
              보험사별 위촉서류를 작성합니다.<br />위촉서류를 모두
              확인하시고, 서명을 해주세요.
            </b>
          </h5>
          {corpNm !== 'gfk' && hasOtherSignM && corpNm !== 'mfs' && corpNm !=='megainfo' && corpNm !=='GLOBAL' && corpNm !== 'sky'
            && (
            <span className="subSpan">
              <h6>
                <b>{hasOtherSignH && <span>흥국생명, </span>} 한화생명의 경우 별도의 자필작성이 있으니 꼭 확인 바랍니다.</b>
              </h6>
            </span>
            )}
        </CContainer>
        <CCardBody className="bottom-card-body">
          {apoDocList.map((apoDoc, index) => {
            let boolVal = false;

            apoDocForm.apoDocCnfmYn.forEach((item) => {
              if (apoDoc.AFCR_NO === item.afcrNo && item.cnfmYn || ((apoDoc.FORM_CAT_DTL_CD  && item.formCatDtlCd) && item.cnfmYn )) { 
                boolVal = true;
              }
            });

            return (
              <CFormGroup
                row
                className="mb-3 formCheckbox"
                key={apoDoc.FORM_NO}
              >
                <CCol xs="2">
                  {corpNm !== 'gfk' && corpNm !=='megainfo' && corpNm !=='sky' && (apoDoc.AFCR_NO === "10009" || (apoDoc.AFCR_NO === "10005" && corpNm !== 'mfs' && corpNm !=='GLOBAL' && corpNm !== 'gfk' && corpNm !=='megainfo')) ? (
                    <label className="component-checkbox">
                      <input
                        type="checkbox"
                        id={`apoDoc${apoDoc.FORM_NO}`}
                      name={`apoDoc${apoDoc.FORM_NO}`}
                      readOnly
                      data-afcr-no={apoDoc.AFCR_NO}
                      data-form-cat-dtl-cd={apoDoc.FORM_CAT_DTL_CD}
                      onClick={onRegistryClick}
                      checked={
                        apoDoc.AFCR_NO === "10009"
                        ? apoDocForm.apoDocHdwtInfo[1].data && boolVal ? true: false
                        : apoDocForm.apoDocHdwtInfo[2].data && boolVal ? true: false
                      }
                      />
                      <i />
                    </label>
                  ) : (
                    <label className="component-checkbox">
                      <input
                        type="checkbox"
                        id={`apoDoc${apoDoc.FORM_NO}`}
                        name={`apoDoc${apoDoc.FORM_NO}`}
                        readOnly
                        data-afcr-no={apoDoc.AFCR_NO}
                        data-form-cat-dtl-cd={apoDoc.FORM_CAT_DTL_CD}
                        onClick={onRegistryClickCheck}
                        checked={boolVal}
                      />
                      <i />
                    </label>
                  )}
                </CCol>
                <CCol xs="10">
                  <CButton
                    className={apoDoc.AFCR_NO === '10005'
                      ? !!(apoDocForm.apoDocHdwtInfo[2].data && boolVal) ? 'isChecked' : ''
                      : boolVal ? 'isChecked' : ''}
                    color="primary"
                    variant="outline"
                    data-afcr-no={apoDoc.AFCR_NO}
                    data-form-cat-dtl-cd={apoDoc.FORM_CAT_DTL_CD}
                    block
                    onClick={onRegistryClick}
                  >
                    {apoDoc.FORM_NM}
                  </CButton>
                </CCol>
              </CFormGroup>
            );
          })}
          <CRow className="text-left">
            <CCol xs="12">
              <p>
                모든 보험사 위촉서류내용에 대해 충분히 이해하고 숙지하였으며,
                이에 대한 동의의 의사표시로 자필서명 합니다.
              </p>
            </CCol>
          </CRow>
          <CRow>
            <CCol xs="12">
              <CButton
                color="primary"
                block
                onClick={handelHdwtSign}
                disabled={
                  !(insert.reqTaskInfo.stCd === '10'
                  || insert.reqTaskInfo.stCd === '99')
                }
              >
                서명하기
              </CButton>
            </CCol>
          </CRow>
          {/* 스카이블루에셋 서명하기 아래 안내멘트 */}
          {(main.corpNo =='62') ? (
              <CRow className="text-left">
                <CCol xs="12">
                  <p style={{paddingTop:"16px"}}>
                    ※ 해당 보험사를 제외한 나머지 보험사의 위촉서류는 일정에 따라 인사담당자가 URL 발송예정입니다.
                  </p>
                </CCol>
              </CRow>
          ): null}
        </CCardBody>
      </div>
      <TheFooter
        step={main.step}
        handleHdwtForApoDocSave={handleHdwtForApoDocSave}
      />
      {apoDocRegPop.isOpen && (
        <ApoDocFormPop
          modal
          afcrNo={apoDocRegPop.afcrNo}
          onClose={onRegPopClose}
        />
      )}
      {hdwtRegPop.isOpen && (
        <ApoDocHdwtRegPop
          modal
          etcYn={0}
          display={hdwtRegPop.isOpen ? 'display' : ''}
          onClose={handelHdwtRegPopClose}
        />
      )}
    </>
  );
};

export default ApoDocFormPage;
